export const getShortlistItems = (state) => state.shortlist?.items || [];
export const getShortlistLoading = (state) =>
  Boolean(state.shortlist?.loading);
export const getShortlistInitialized = (state) =>
  Boolean(state.shortlist?.initialized);
export const getShortlistError = (state) => state.shortlist?.error || null;
export const isPlayerShortlisted = (playerId) => (state) =>
  (state.shortlist?.items || []).some(
    (item) => String(item.player) === String(playerId)
  );
